/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { useEffect, useContext, useState, useRef } from "react"
import { navigate } from "gatsby"

import SitesContext from "../../context/site-context"
import { colors, ab } from "../../theme"

const SitesFilter = ({
  heading,
  countryText,
  industryText,
  lessText,
  moreText,
  plzOrtPlaceholder,
  companyText,
  plzOrtText,
  plzOrtNotice,
  industriesNames,
}) => {
  const { getFilters, setSerach } = useContext(SitesContext)
  const [countries, setCountries] = useState([""])
  const [industries, setIndustries] = useState([""])
  const [companys, setCompanys] = useState([""])
  const [checkedValues, setCheckedValues] = useState({})
  const [radioValue, setRadioValue] = useState({})
  const [showAllIndusty, setShowAllIndusty] = useState(true)
  const [showAllCountry, setShowAllCountry] = useState(true)
  const [showAllCompanyNames, setShowAllCompanyNames] = useState(false)
  const [inputValue, setInputValue] = useState("")
  const [plzValue, setPlzValue] = useState("")
  const [plzCountry, setPlzCountry] = useState("")
  const initializedFromUrl = useRef(false)

  const [query, setQuery] = useState({
    countries: [],
    industries: [],
    companys: [],
  })

  const handleInputChange = (event) => {
    setQuery({
      countries: [],
      industries: [],
      companys: [],
    })
    setRadioValue()
    setInputValue(event.target.value)
    if (event.target.name === "ortPlz") {
      setQuery((prevQuery) => ({
        ...prevQuery,
        ortPlz: event.target.value,
      }))
    }
  }

  const setCheckboxValue = (name, value = true) => {
    setCheckedValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }))
  }

  const handleCheckboxChange = (name) => {
    setCheckboxValue(name, !checkedValues[name])
  }

  const handleRadioChange = (value) => {
    if (radioValue === value) {
      setRadioValue("")
      setQuery((prevQuery) => ({
        ...prevQuery,
        countries: [],
      }))
    } else {
      setRadioValue(value)
      setQuery((prevQuery) => ({
        ...prevQuery,
        countries: [value],
      }))
    }
  }

  const setCheckboxFilter = (checkbox) => {
    const { value, checked, name } = checkbox
    const values = value.split("__")

    if (checked) {
      if (values[0] === "industries") {
        setQuery((prevQuery) => ({
          ...prevQuery,
          industries: [...prevQuery.industries, values[1]],
        }))
      }
      if (values[0] === "companys") {
        setQuery((prevQuery) => ({
          ...prevQuery,
          companys: [...prevQuery.companys, values[1]],
        }))
      }
    } else {
      if (values[0] === "industries") {
        setQuery((prevQuery) => {
          return {
            ...prevQuery,
            industries: prevQuery.industries.filter(
              (country) => country !== values[1]
            ),
          }
        })
      }

      if (values[0] === "companys") {
        setQuery((prevQuery) => {
          return {
            ...prevQuery,
            companys: prevQuery.companys.filter(
              (country) => country !== values[1]
            ),
          }
        })
      }
    }
    // query.push(value)
    handleCheckboxChange(name)
  }

  const handleChange = (e) => {
    setCheckboxFilter(e.target)
  }

  const handlePlzChange = (event) => {
    const value = event.target.value
    setPlzValue(value)
    //if plzCountry is empty
    if (!plzCountry || !value) {
      return
    }
    updateOrtPlz(value, plzCountry)
  }

  const handlePlzCountryChange = (event) => {
    //if plzValue is empty

    const value = event.target.value
    setPlzCountry(value)
    //find set  setCheckboxValue to value
    handleRadioChange(`${value}`, true)
    if (!plzValue || !value) {
      return
    }
    updateOrtPlz(plzValue, value)
  }

  const updateOrtPlz = (plz, country) => {
    // Only set ortPlz if both plz and country are provided
    const ortPlzValue = plz && country ? `${plz},${country}` : ""
    setInputValue(ortPlzValue)
    setQuery((prevQuery) => ({
      ...prevQuery,
      ortPlz: ortPlzValue || undefined,
    }))
  }

  useEffect(() => {
    let filters = getFilters()
    if (typeof filters[0] !== "undefined") {
      setCountries(Array.from(filters[0]))
    }

    if (typeof filters[1] !== "undefined") {
      setIndustries(Array.from(filters[1]))
    }

    if (typeof filters[2] !== "undefined") {
      setCompanys(Array.from(filters[2]))
    }
  }, [getFilters(), checkedValues])

  useEffect(() => {
    if (typeof radioValue === "object") {
      setQuery((prevQuery) => ({
        ...prevQuery,
        countries: [],
      }))
    }
  }, [radioValue])

  useEffect(() => {
    setSerach(query)

    if (typeof window === "undefined") return
    if (!initializedFromUrl.current) return

    const params = new URLSearchParams(window.location.search)
    if (query.countries?.length && !query.countries[0].cancelable) {
      // exclude events
      params.set("countries", query.countries)
    } else {
      params.delete("countries")
    }

    if (query.companys?.length && !query.companys[0].cancelable) {
      params.set("companys", query.companys.join(","))
    } else {
      params.delete("companys")
    }

    if (query.industries?.length && !query.industries[0].cancelable) {
      params.set("industries", query.industries.join(","))
    } else {
      params.delete("industries")
    }

    if (query.ortPlz) {
      params.set("ortPlz", query.ortPlz)
    } else {
      params.delete("ortPlz")
    }

    const qs = params.toString()

    const newPath = window.location.pathname + (qs ? `?${qs}` : "")
    const current = window.location.pathname + window.location.search
    if (newPath !== current) {
      navigate(newPath, { replace: true })
    }
  }, [query, checkedValues])

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    const countriesParam = searchParams.get("countries")
    const industriesParam = searchParams.get("industries")?.split(",")
    const companysParam = searchParams.get("companys")?.split(",")
    const ortPlzParam = searchParams.get("ortPlz")

    const query = {
      countries: [],
      industries: [],
      companys: [],
    }

    if (countriesParam) {
      handleRadioChange(countriesParam)
      query.countries = [countriesParam]
    }

    if (industriesParam) {
      query.industries = industriesParam

      for (let i = 0; i < industriesParam.length; i++) {
        const industry = industriesParam[i]
        setCheckedValues((prev) => ({
          ...prev,
          [`industries__${industry}`]: true,
        }))

        setCheckboxValue(`industries__${industry}`, true)
      }
    }

    if (companysParam) {
      query.companys = companysParam

      for (let i = 0; i < companysParam.length; i++) {
        const company = companysParam[i]
        setCheckedValues((prev) => ({
          ...prev,
          [`companys__${company}`]: true,
        }))

        setCheckboxValue(`companys__${company}`, true)
      }
    }

    if (ortPlzParam) {
      setInputValue(ortPlzParam)
      // Split ortPlzParam into plz and country if possible
      const [plz, country] = ortPlzParam.split(",")
      setPlzValue(plz || "")
      setPlzCountry(country || "")
      query.ortPlz = ortPlzParam
    }

    setQuery(query)
    initializedFromUrl.current = true
  }, [])

  return (
    <div
      className="site-filters"
      sx={{
        pr: ab({ md: "10px" }),
        pt: "25px",
        minWidth: ab({ _: "100%", md: "320px" }),
      }}
    >
      <h3
        sx={{
          mt: 0,
          mb: 0,
          pb: "6px",
          borderBottom: "solid 1px",
        }}
      >
        {heading}
      </h3>

      <from
        className="form"
        sx={{
          lable: {
            textTransform: "capitalize",
          },
        }}
      >
        <div
          sx={{
            ul: {
              m: 0,
              p: 0,
              display: "flex",
              maxWidth: " 100%",
              flexWrap: "wrap",
              transition: "ease-in-out all 500ms",
              overflow: "hidden",
              position: "relative",
            },
            h4: {
              mb: "5px",
              mt: 3,
            },
            "> div": {
              display: "grid",
              borderBottom: "solid 1px",
              li: {
                listStyle: "none",
                width: "50%",
              },
              button: {
                pt: "15px",
                border: 0,
                bg: "transparent",
                fontSize: "12px",
                cursor: "pointer",
              },
              'input[type="checkbox"], input[type="radio"]': {
                display: "none",
              },
              'input[type="text"], select': {
                position: "relative",
                border: "0 none ",
                background: "#f5f5f5",
                borderRadius: "10px",
                padding: " 10px",
                mb: 1,
              },
              "input::placeholder": {
                color: "#bab7b7",
              },
              "&.plz-search  span.icon": {
                position: "relative",
                display: "inline-block",
                top: "5px",
                width: "10px",
                marginLeft: "-25px",
                "::after": {
                  transition: "all .3s",
                  content: "''",
                  position: "absolute",
                  right: "10px",
                  top: "8px",
                  fontSize: "15px",
                  transform: "rotate(-45deg)",
                  border: "solid 1px #5a5d5f",
                  height: "7px",
                  width: "7px",
                  borderColor: " transparent transparent #5a5d5f #5a5d5f",
                },
              },
              strong: {
                fontWeight: "bold",
              },

              ".btn": {
                textAlign: ab({ _: "center", md: "right" }),
                margin: ab({ _: "5px 0 ", md: "0" }),
                button: {
                  display: ab({ _: "none", md: "inline-block" }),
                  cursor: "pointer",
                },
                span: {
                  display: ab({ _: "inline-block", md: "none" }),
                  height: "25px",
                  width: "25px",
                  borderLeft: "solid 1px",
                  borderBottom: "solid 1px",
                  cursor: "pointer",
                },
              },

              label: {
                display: "flex",
                cursor: "pointer",
                textTransform: "capitalize",
                fontSize: "15px",
                span: {
                  mt: "7px",
                  display: "inline-block",
                  height: "25px",
                  width: "25px",
                  borderRadius: "20px",
                  border: "2px  solid #f5f5f5",
                  bg: "#f5f5f5",
                  position: "absolute",
                },
                "span.checked": {
                  bg: colors.modes["group"].primary,
                },
                em: {
                  lineHeight: "18px",
                  ml: "30px",
                  fontStyle: "normal",
                  padding: "10px 0 ",
                  display: "inline-block",
                },
              },
            },
          }}
        >
          <h4>{countryText}</h4>
          <div>
            <ul
              sx={{
                maxHeight: ab({
                  _: showAllCountry ? "" : "0",
                  md: showAllCountry ? "320px" : "45px",
                }),
                overflowY: ab({
                  _: showAllCountry ? "visible !important" : "hidden",
                  md: showAllCountry ? "" : "45px",
                }),
              }}
            >
              {countries
                .slice()
                .sort((a, b) =>
                  a.localeCompare(b, "de", { sensitivity: "base" })
                )
                .map((el, i) => (
                  <li key={el}>
                    <label htmlFor={el} onClick={(e) => handleRadioChange(el)}>
                      {" "}
                      <span
                        className={
                          radioValue === el ? "checked" : "not-checked"
                        }
                      ></span>
                      <em>{el} </em>
                    </label>
                    <input
                      className={radioValue ? "added" : "not-added"}
                      type="radio"
                      name={`country`}
                      id={el}
                      checked={radioValue === el}
                      value={el}
                      onChange={(e) => handleRadioChange(e)}
                    />
                  </li>
                ))}
            </ul>
            <div className="btn">
              <button onClick={() => setShowAllCountry(!showAllCountry)}>
                {showAllCountry ? lessText : moreText}
              </button>
              <span
                role="button"
                onClick={() => setShowAllCountry(!showAllCountry)}
                sx={{
                  transform: showAllCountry
                    ? "rotate(135deg)"
                    : "rotate(-45deg)",
                }}
              ></span>
            </div>
          </div>

          <div
            sx={{
              pb: "20px",
            }}
            className="plz-search"
          >
            <h4>{plzOrtText}</h4>
            <div sx={{ display: "flex", gap: 2 }}>
              <input
                type="text"
                name="plz"
                placeholder={plzOrtPlaceholder}
                value={plzValue}
                onChange={handlePlzChange}
                sx={{ flexGrow: 2 }}
              />
              <select
                name="plzCountry"
                value={plzCountry}
                onChange={handlePlzCountryChange}
                sx={{ flexGrow: 1 }}
              >
                <option value="">{countryText}</option>
                {countries
                  .slice()
                  .sort((a, b) =>
                    a.localeCompare(b, "de", { sensitivity: "base" })
                  )
                  .map((el) => {
                    let optionValue = el
                    let label = el.charAt(0).toUpperCase() + el.slice(1)
                    if (el === "united states of america") {
                      optionValue = "USA"
                      label = "USA"
                    }
                    return (
                      <option key={optionValue} value={optionValue}>
                        {label}
                      </option>
                    )
                  })}
              </select>
              <span className="icon"></span>
            </div>
            <span
              sx={{
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {plzOrtNotice}
            </span>
          </div>

          <div>
            <h4>{industryText} </h4>
            <div>
              <ul
                sx={{
                  maxHeight: ab({
                    _: showAllIndusty ? "" : "0",
                    md: showAllIndusty ? "800px" : "45px",
                  }),
                  "li:nth-child(odd)": {
                    maxWidth: "115px",
                  },
                }}
              >
                {industries
                  .slice()
                  .sort((a, b) =>
                    a.localeCompare(b, "de", { sensitivity: "base" })
                  )
                  .map((el, i) => {
                    return (
                      <li key={el}>
                        <label htmlFor={el}>
                          <span
                            className={
                              checkedValues[`industries__${el}`]
                                ? "checked"
                                : "not-checked"
                            }
                          ></span>
                          <em>
                            {industriesNames[el] !== undefined
                              ? industriesNames[el]
                              : el}
                          </em>{" "}
                        </label>
                        <input
                          type="checkbox"
                          checked={checkedValues[`industries__${el}`]}
                          id={el}
                          name={`industries__${el}`}
                          value={`industries__${el}`}
                          onChange={(e) => handleChange(e)}
                        />
                      </li>
                    )
                  })}
              </ul>
              <div className="btn">
                <button onClick={() => setShowAllIndusty(!showAllIndusty)}>
                  {showAllIndusty ? lessText : moreText}
                </button>
                <span
                  role="button"
                  onClick={() => setShowAllIndusty(!showAllIndusty)}
                  sx={{
                    transform: showAllIndusty
                      ? "rotate(135deg)"
                      : "rotate(-45deg)",
                  }}
                ></span>
              </div>
            </div>
          </div>

          <div>
            <h4>{companyText} </h4>
            <div>
              <ul
                sx={{
                  maxHeight: ab({
                    _: showAllCompanyNames ? "" : "0",
                    md: showAllCompanyNames ? "1300px" : "190px",
                  }),
                  ">li ": {
                    width: "100% !important",
                  },
                }}
              >
                {companys
                  .slice()
                  .sort((a, b) =>
                    a.localeCompare(b, "de", { sensitivity: "base" })
                  )
                  .map((el, i) => (
                    <li key={el}>
                      <label htmlFor={el}>
                        <span
                          className={
                            checkedValues[`companys__${el}`]
                              ? "checked"
                              : "not-checked"
                          }
                        ></span>
                        <em sx={{ textTransform: "none" }}>{el}</em>{" "}
                      </label>
                      <input
                        type="checkbox"
                        checked={checkedValues[`companys__${el}`]}
                        id={el}
                        name={`companys__${el}`}
                        value={`companys__${el}`}
                        onChange={(e) => handleChange(e)}
                      />
                    </li>
                  ))}
              </ul>
              <div className="btn">
                <button
                  onClick={() => setShowAllCompanyNames(!showAllCompanyNames)}
                >
                  {showAllCompanyNames ? lessText : moreText}
                </button>
                <span
                  role="button"
                  onClick={() => setShowAllCompanyNames(!showAllCompanyNames)}
                  sx={{
                    transform: showAllCompanyNames
                      ? "rotate(135deg)"
                      : "rotate(-45deg)",
                  }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </from>
    </div>
  )
}

SitesFilter.propTypes = {}

export default SitesFilter
